const STORAGE_PREFIX = "fieldApp.customMaintenanceItems.";

function storageKey(farmId) {
  return `${STORAGE_PREFIX}${farmId || "default"}`;
}

export function loadCustomMaintenanceItems(farmId) {
  try {
    const raw = window.localStorage.getItem(storageKey(farmId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map((item) => String(item || "").trim())
      .filter(Boolean)
      .slice(0, 100);
  } catch (_error) {
    return [];
  }
}

export function saveCustomMaintenanceItems(farmId, items) {
  const cleaned = Array.from(
    new Set(
      (items || [])
        .map((item) => String(item || "").trim())
        .filter(Boolean)
    )
  ).slice(0, 100);
  try {
    window.localStorage.setItem(storageKey(farmId), JSON.stringify(cleaned));
  } catch (_error) {
    // ignore quota / private mode
  }
  return cleaned;
}

export function addCustomMaintenanceItem(farmId, name) {
  const trimmed = String(name || "").trim();
  if (!trimmed) return loadCustomMaintenanceItems(farmId);
  const current = loadCustomMaintenanceItems(farmId);
  if (current.some((item) => item.toLowerCase() === trimmed.toLowerCase())) {
    return current;
  }
  return saveCustomMaintenanceItems(farmId, [trimmed, ...current]);
}
